export default __webpack_public_path__ + "static/media/tsuruda.21a00735.jpeg";